
export const getDefaultState = () => {
  return {
    pageList: [],
  };
};
export const state = getDefaultState();
